var _effectorFileName = "/src/page-content/pair-lessons/ui.tsx";
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { WebPageJsonLd } from 'next-seo';
import { HelpAchieveGoals } from '@/page-content/pair-lessons/components/help-achieve-goals';
import { MainPairLessons } from '@/page-content/pair-lessons/components/main-pair-lessons';
import { PlusesPairLessons } from '@/page-content/pair-lessons/components/pluses-pair-lessons';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { SERVICES_LIST } from '@/widgets/layouts/main/constants/services-list';
import { Pricing } from '@/widgets/layouts/main/pricing';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
export const PairLessonsPage = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation('pair-lessons-page');
  return <>
      <PageSeo title={t('seo.title')} description={t('seo.description')} />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} name={`${APP_TITLE} - ${t('seo.name')}`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} description={t('seo.description')} about={t('seo.about', {
      returnObjects: true
    }) as string[]} />

      <MainPairLessons />

      <HelpAchieveGoals />

      <PlusesPairLessons />

      <Pricing servicesList={SERVICES_LIST} />

      <Reviews />

      <CallToAction withForm />
    </>;
};
PairLessonsPage.Layout = MainLayout;